import { render, staticRenderFns } from "./withdrawal-record.vue?vue&type=template&id=2449db44&scoped=true&"
import script from "./withdrawal-record.vue?vue&type=script&lang=js&"
export * from "./withdrawal-record.vue?vue&type=script&lang=js&"
import style0 from "./withdrawal-record.vue?vue&type=style&index=0&id=2449db44&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2449db44",
  null
  
)

export default component.exports